import { render } from "./EventEditor.vue?vue&type=template&id=5f75499d&ts=true"
import script from "./EventEditor.vue?vue&type=script&lang=ts"
export * from "./EventEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__